const activeAnimations = new WeakMap();

function milliseconds(value) {
  const number = parseFloat(value) || 0;
  return value.trim().endsWith("ms") ? number : number * 1000;
}

export default function animateCSS(element, animationName, callback) {
  const node = element instanceof Element ? element : document.querySelector(element);
  if (!node) return;
  const previous = activeAnimations.get(node);
  if (previous) previous(true);
  const show = animationName === "fadeIn";
  if (show) {
    node.style.display = node.dataset.display || "";
    if (window.getComputedStyle(node).display === "none") node.style.display = "block";
  } else {
    const display = window.getComputedStyle(node).display;
    if (display !== "none") node.dataset.display = display;
  }

  let finished = false;
  let started = false;
  let timer;
  const finish = (replaced = false) => {
    if (finished) return;
    finished = true;
    clearTimeout(timer);
    node.removeEventListener("animationend", onEnd);
    node.removeEventListener("animationcancel", onEnd);
    node.removeEventListener("animationstart", onStart);
    node.classList.remove("animated", animationName);
    activeAnimations.delete(node);
    if (replaced) return;
    if (!show) node.style.display = "none";
    if (typeof callback === "function") callback(node, animationName);
  };
  const onEnd = (event) => {
    if (event.type === "animationcancel" && !started) return;
    if (event.target === node && (!event.animationName || event.animationName === animationName)) finish();
  };
  const onStart = (event) => {
    if (event.target === node && event.animationName === animationName) started = true;
  };
  activeAnimations.set(node, finish);
  node.addEventListener("animationend", onEnd);
  node.addEventListener("animationcancel", onEnd);
  node.addEventListener("animationstart", onStart);
  node.classList.add("animated", animationName);
  const style = window.getComputedStyle(node);
  const durations = style.animationDuration.split(",").map(milliseconds);
  const delays = style.animationDelay.split(",").map(milliseconds);
  const timeout = Math.max(...durations.map((duration, index) => duration + delays[index % delays.length]));
  if (timeout <= 0 || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) {
    finish();
  } else {
    timer = setTimeout(() => finish(), timeout + 100);
  }
}

export function fadeToggleListener(buttonSelector, toggleSelector) {
  const buttonEl = document.querySelector(buttonSelector);
  if (buttonEl !== null && buttonEl !== undefined) {
    buttonEl.addEventListener("click", (event) => {
      const elem = document.querySelector(toggleSelector);
      if (!elem) return;
      event.preventDefault();

      let isVisible = !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
      let animationName = isVisible ? "fadeOut" : "fadeIn";

      animateCSS(elem, animationName);
    });
  }
}

export function fadeToggleButtons(event) {
  event.preventDefault();
  event.currentTarget.parentNode.querySelectorAll("a.bigbutton:not(:first-child)").forEach((elem) => {
    let isVisible = !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    let animationName = isVisible ? "fadeOut" : "fadeIn";
    elem.classList.remove("disabled");
    animateCSS(elem, animationName, (node, animationName) => {
      if (animationName === "fadeOut") {
        node.classList.add("disabled");
      }
    });
  });
}
